import { RouteConfig } from "../../config/router/router.config";

export const removeGSIDInParam = (params: string) =>
  `?${params
    .slice(1)
    .split("&")
    .filter((v) => !v.includes("gsid"))
    .join("&")}`;

/**
 * Parse location path to document title
 * @param key
 * @returns
 */
export const routeToDocumentTitle = (key: string) => {
  const routes: Record<string, string> = {};

  return routes[key] || "React Template";
};

export const routeLevelChecker = ({
  route,
  level,
}: {
  route: RouteConfig;
  level?: number;
}) => {
  if (typeof level !== "number") return false;
  const routeLevelMaxChecker =
    typeof route.roleLevelMax === "number" && level <= route.roleLevelMax;
  const routeLevelMinChecker =
    typeof route.roleLevelMin === "number" && level >= route.roleLevelMin;
  const routeLevelExactChecker =
    typeof route.roleLevelExact === "number" && level === route.roleLevelExact;

  if (typeof route.roleLevelExact === "number") return routeLevelExactChecker;

  if (
    typeof route.roleLevelMin === "number" &&
    typeof route.roleLevelMax === "number"
  )
    return routeLevelMaxChecker && routeLevelMinChecker;

  if (typeof route.roleLevelMin === "number") return routeLevelMinChecker;
  if (typeof route.roleLevelMax === "number") return routeLevelMaxChecker;
  return true;
};
